import { createTheme, ThemeOptions } from '@mui/material/styles';

export default createTheme({
  status: {
    danger: '#e53e3e',
  },
  palette: {
    primary: {
      main: '#84281c',
      darker: '#053e85',
    },
    neutral: {
      main: '#64748B',
      contrastText: '#fff',
    },
    button: {
        main: '#c16054',
    }
  },
} as ThemeOptions);


export const palette = {


  gray: {light:'#ebe9e6', medium: '#d1cfcd' ,dark: '#b5b3b0'},

  red: '#c02d1a',

  green: '#21ad2f',

  rodrimaq_red: '#c02d1a',

  light_red: '#c25648',

  blue: {light: '#8fbaf2', medium : '#2d4ca8' ,dark: '#1f2666'},

  orange: '#f57e42',

  purple: '#c203fc',

  navbar: '#393852',

  yellow: '#ff9e0d',

  table: {
    even: '#fad7d4',
    odd: '#e3c1bf',
    header: '#f08e86'
  }

}


export const GraphsPalette = {
  
  getColors: function (index : number) {
    if(index > this.colors.length - 1) {
      const newIndex = index % this.colors.length;
      return this.colors[newIndex];
    } else {
      return this.colors[index];
    }
  },

  
  colors:['#d45087','#ffa600',  '#003f5c', '#ff7c43',   '#a05195',  '#665191', '#f95d6a',  '#2f4b7c']


}

